import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiUtility } from 'countable@helpers';
import { sortTypeModel, sortTypesOptions } from 'countable@model';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { SharedModule } from '../../shared/shared.module';
import { CoreModule } from 'src/app/core/core.module';

@Component({
  selector: 'app-workbook-sorting',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatTooltipModule, MatRadioModule, SharedModule, CoreModule],
  templateUrl: './workbook-sorting.component.html',
  styleUrl: './workbook-sorting.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkbookSortingComponent {
  sortArray: sortTypeModel[] = sortTypesOptions;
  selectedSort: FormControl = new FormControl(this.sortArray[0]);
  public isUpArrowDisabled: WritableSignal<boolean> = signal<boolean>(false);
  public isDownArrowDisabled: WritableSignal<boolean> = signal<boolean>(false);
  public groupisASC: WritableSignal<boolean> = signal<boolean>(false);
  public amountisASC: WritableSignal<boolean> = signal<boolean>(false);
  public manualSelectedRow: WritableSignal<number> = signal<number>(-1);
  private _sortData: any;
  private aiUtil: typeof AiUtility = AiUtility;

  @Output() closeMenu = new EventEmitter();

  @Input()
  set sortData(data) {
    if (data && data?.subGroupChildren) {
      this._sortData = data.subGroupChildren.map(row => ({ ...row, isChecked: false ,
        formattedCurrYear: row?.currYearValue === 0 ? '-' : this.aiUtil.showFormattedNumber(row?.currYearValue)}));
    }
    this.resetValues();
  }

  get sortData() {
    return this._sortData;
  }

  constructor() {

  }


  private resetValues() {
    this.selectedSort.setValue(this.sortArray[0]);
    this.isUpArrowDisabled.set(false);
    this.isDownArrowDisabled.set(false);
    this.groupisASC.set(false);
    this.amountisASC.set(false);
    this.manualSelectedRow.set(-1);
  }

  public toggleSort(key: string) {
    switch (key) {
      case 'group':
        this.groupisASC.set(!this.groupisASC());
        this.groupisASC() ? this.sortData.sort((a, b) => 0 - (a.rowName.toLowerCase() > b.rowName.toLowerCase() ? 1 : -1)) : this.sortData.sort((a, b) => 0 - (a.rowName.toLowerCase() > b.rowName.toLowerCase() ? -1 : 1));
        break;

      case 'amount':
        this.amountisASC.set(!this.amountisASC());
        this.amountisASC() ? this.sortData.sort(function (a, b) { return a.currYearValue - b.currYearValue }) : this.sortData.sort(function (a, b) { return b.currYearValue - a.currYearValue });
        break;

      default:
        break;
    }
  }

  public updatePosition(value: boolean, index: number) {
    this.sortData[index].isChecked = value;
    if (this.sortData.find(x => x.isChecked)) {
      this.updateIndexs(index);
    } else {
      this.manualSelectedRow.set(-1);
      this.isUpArrowDisabled.set(false);
      this.isDownArrowDisabled.set(false);
    }
  }

  public swapPositions(value: string) {
    let index = -1;
    value === 'UP' ? (index = this.manualSelectedRow() - 1) : (index = this.manualSelectedRow() + 1);
    this.sortData.splice(index, 0, (this.sortData.splice(this.manualSelectedRow(), 1)[0]));
    this.updateIndexs(index);
  }

  private updateIndexs(index: number) {
    this.manualSelectedRow.set(index);
    this.isUpArrowDisabled.set(index === 0);
    this.isDownArrowDisabled.set(index === this.sortData.length - 1);
  }


}
